var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{ref:"templateTypeTree",attrs:{"data":_vm.data,"node-key":"key","default-expand-all":"","expand-on-click-node":false},on:{"node-click":_vm.checkNode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }